/**
 * 艺术家的数据模拟
 * @type {[{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{menuChild: [{img: {}, imgTitle: string, material: string, author: string, styleOption: [{name: string, key: string},{name: string, key: string},{name: string, key: string},{name: string, key: string},{name: string, key: string},null,null], title: string, dimension: string, key: string, age: string, desc: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string}]},{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string}]},{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{title: string, key: string},{title: string, key: string},{title: string, key: string}]}]}
 */
export const tabsOption = [
  {
    key: "collectible",
    title: "收藏品",
    menuChild: [
      {
        key: "sort",
        title: "分类",
        menuChild: [
          {
            key: "all",
            title: "全部",
            itemOption: [
              {
                key: "bsf",
                title: "青山不墨",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_1.png")
              },
              {
                title: "刘海栗-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_2.png")
              },
              {
                title: "吴作人-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_3.png")
              },
              {
                title: "余振飞-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_4.png")
              },
              {
                title: "赵朴初-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_5.png")
              },
              {
                title: "冰心-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_6.png")
              },
              {
                title: "华罗庚-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_7.png")
              },
              {
                title: "风华正茂",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_8.png")
              },
              {
                title: "龙腾",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_9.png")
              },
              {
                title: "李可染",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_1.png")
              },
              {
                title: "梁黄胄",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_2.png")
              },
              {
                title: "林风眠",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_3.png")
              },
              {
                title: "钓虾",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_4.png")
              },
              {
                title: "丹青吟-白雪石",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_5.png")
              },
              {
                title: "水墨-夏",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_6.png")
              },
              {
                title: "水墨-醉了苗家",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_7.png")
              },
              {
                title: "合围",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_8.png")
              },
              {
                title: "蛙声十里",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_9.png")
              },
              {
                title: "丹青吟-何香凝",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_10.png")
              },
              {
                title: "黄宾虹",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_11.png")
              },
              {
                title: "丹青吟-傅抱石",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_12.png")
              }
            ]
          },
          {
            key: "calligraphyInscriptions",
            title: "书法题字",
            itemOption: [
              {
                key: "bsf",
                title: "青山不墨",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_1.png")
              },
              {
                title: "刘海栗-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_2.png")
              },
              {
                title: "吴作人-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_3.png")
              },
              {
                title: "余振飞-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_4.png")
              },
              {
                title: "赵朴初-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_5.png")
              },
              {
                title: "冰心-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_6.png")
              },
              {
                title: "华罗庚-题字",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_7.png")
              },
              {
                title: "风华正茂",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_8.png")
              },
              {
                title: "龙腾",
                material: "书法", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/sf/img_9.png")
              }
            ]
          },
          {
            key: "chinese",
            title: "水墨国画",
            itemOption: [
              {
                title: "李可染",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_1.png")
              },
              {
                title: "梁黄胄",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_2.png")
              },
              {
                title: "林风眠",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_3.png")
              },
              {
                title: "钓虾",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_4.png")
              },
              {
                title: "丹青吟-白雪石",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_5.png")
              },
              {
                title: "水墨-夏",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_6.png")
              },
              {
                title: "水墨-醉了苗家",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_7.png")
              },
              {
                title: "合围",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_8.png")
              },
              {
                title: "蛙声十里",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_9.png")
              },
              {
                title: "丹青吟-何香凝",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_10.png")
              },
              {
                title: "黄宾虹",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_11.png")
              },
              {
                title: "丹青吟-傅抱石",
                material: "水墨国画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/smgh/img_12.png")
              }
            ]
          },
          {
            key: "figureOil",
            title: "人物油画",
            itemOption: [
              {
                title: "习近平",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img.png")
              },{
                title: "江泽民",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_1.png")
              },{
                title: "胡耀邦",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_2.png")
              },{
                title: "曾宪梓",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_3.png")
              },{
                title: "村山富市",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_4.png")
              },{
                title: "洪都拉斯总统卡耶哈斯",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_5.png")
              },{
                title: "李嘉诚",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_6.png")
              },{
                title: "霍英东",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_7.png")
              },{
                title: "李兆基",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_8.png")
              },{
                title: "陈丽华",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_9.png")
              },{
                title: "白淑湘",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_13.png")
              },{
                title: "冰心",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_10.png")
              },{
                title: "何鸿燊",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_11.png")
              },{
                title: "陈永裁与夫人",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_12.png")
              },{
                title: "金庸",
                material: "人物油画", // 材质
                dimension: "136 x 189cm", // 尺寸
                img: require("@/assets/artWork/collectible/rw/img_14.png")
              },
            ]
          },
          {
            key: "stoneRhyme",
            title: "石韵画",
            itemOption: []
          },
          {
            key: "world",
            title: "世界系列",
            itemOption: []
          }
        ]
      },
      {
        key: "author",
        title: "作者",
        menuChild: []
      },
      {
        key: "dimension",
        title: "尺寸",
        menuChild: []
      },
      {
        key: "price",
        title: "价格",
        menuChild: []
      }
    ]
  },
  {
    key: "appraisalCenter",
    title: "鉴定中心",
    menuChild: [
      {
        key: "identificationEvaluation",
        title: "鉴定与评估委员会"
      },
      {
        key: "collectionEvaluation",
        title: "收藏评估委员会"
      }
    ]
  },
  {
    key: "wenChiao",
    title: "文交系统",
    menuChild: [
      {
        key: "south",
        title: "南方文交所"
      },
      {
        key: "shenzhenWjs",
        title: "深圳文交所"
      }
    ]
  }
];
